<!-- Button -->
<div [matMenuTriggerFor]="userActions" mat-icon-button class="header-dropdown">
    <span class="relative">
        <!--@if (user) {
        <img class="h-7 w-7 rounded-full" [src]="user" />
        }-->
        @if (user) {
            <div class="flex items-center gap-2 cursor-pointer">
                <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                <p>{{user.firstName}} {{user.lastName}}</p>
                <mat-icon class="down-arrow" [svgIcon]="'heroicons_outline:chevron-down'"></mat-icon>
            </div>
        } @else {
            <mat-icon  [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
    </span>
</div>

<!--<div [matMenuTriggerFor]="userActions" mat-icon-button>
    <span class="relative">
        &lt;!&ndash;@if (user) {
        <img class="h-7 w-7 rounded-full" [src]="user" />
        }&ndash;&gt;
        @if (user) {
            <div class="flex items-center gap-2 cursor-pointer">
                <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                <p>{{user.firstName}} {{user.lastName}}</p>
            </div>
        } @else {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
    </span>
</div>-->

<mat-menu #userActions="matMenu" [xPosition]="'before'">
<!--    <button mat-menu-item>-->
<!--        <span class="flex flex-col leading-none">-->
<!--            <span>Signed in as</span>-->
<!--            <span class="mt-1.5 text-md font-medium">{{ user?.email ? user.email : ''  }}</span>-->
<!--        </span>-->
<!--    </button>-->
<!--    <mat-divider class="my-2"></mat-divider>-->
<!--    <button (click)="_router.navigateByUrl('/profile')" mat-menu-item>-->
<!--        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>-->
<!--        <span>Profile</span>-->
<!--    </button>-->
    <button (click)="redirectToSetting()" mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{isPartner ? LABELS.MY_ACCOUNT : LABELS.MY_PROFILE}}</span>
    </button>
    <button (click)="redirectToChangePassword()" mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
        <span>{{LABELS.CHANGE_PASSWORD}}</span>
    </button>
    <!--  <button mat-menu-item [matMenuTriggerFor]="userStatus">
          <mat-icon
              [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"
          ></mat-icon>
          <span>Status</span>
      </button>-->
    <mat-divider class="my-2"></mat-divider>
    <button (click)="signOut()" mat-menu-item>
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>{{LABELS.SIGN_OUT}}</span>
    </button>
</mat-menu>

<!--<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>-->
